import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService, TimerService } from '../services/services.index';

import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster/angular2-toaster';

import { AppCore } from 'app/app.core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  providers: [
    ToasterService,
    AuthService,
    TimerService
  ]
})
export class FullLayoutComponent extends AppCore implements OnInit, OnDestroy {

  public usuario;

  public timer_control = {
    display: false,
    temp_title: ''
  }
  public display_time: boolean = false;


  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 10000,
    mouseoverTimerStop: true,
    limit: 1
  });

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private _toasterService: ToasterService,
    public timer: TimerService
  ) { super(); }

  public disabled: boolean = false;
  public status: { isopen: boolean } = { isopen: false };
  public tt = null;
  public toggled(open: boolean): void { }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
    this.usuario = this._auth.getUser();
  }

  ngOnDestroy(): void {
    this.timer.destroy();
  }

  public logout(): void {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this._router.navigate(['/login']);
  }

  public showToast(type: string, title: string, message: string): any {
    this._toasterService.pop(type, title, message);
  }

  public getData(result: any): any {
    if (result.code === 1) {
      this.showToast('error', 'Error', result.message);
      this._router.navigate(['/login']);
    }
    if (result.status === 'ok') {
      return result.data;
    } else {
      this.showToast('error', 'Error', result.message);
      return null;
    }
  }

  public navigate(link: string[]): void {
    this._router.navigate(link);
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts